import React from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import { TButtonsConfig } from './types/TButtons';

const ButtonBase: React.FC<TButtonsConfig> = ({
  as = 'button',
  kind = 'primary',
  additionalModifiers,
  elementRef,
  ...rest
}) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [kind, ...(additionalModifiers ?? [])],
  });

  return <Box {...rest} ref={elementRef} name="Button" as={as} {...conditionalProps} />;
};

export default React.memo(ButtonBase);
